import { render, staticRenderFns } from "./memberRewards.vue?vue&type=template&id=72afaac2&scoped=true&"
import script from "./memberRewards.vue?vue&type=script&lang=js&"
export * from "./memberRewards.vue?vue&type=script&lang=js&"
import style0 from "./memberRewards.vue?vue&type=style&index=0&id=72afaac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72afaac2",
  null
  
)

export default component.exports